module.exports = __webpack_public_path__ + "static/guy-with-chair-5ddcaa952d3f3cb6141209f285b4d19c.png";